import React, { useEffect } from 'react';
import styled from 'styled-components';
import TaskForm from './TaskForm';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  position: relative;
  width: 95%;
  max-width: 500px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0;
  max-height: 90vh;
  overflow-y: auto;
`;

const TaskModal = ({ isOpen, task, onClose, onSave }) => {
  useEffect(() => {
    //console.log('TaskModal props updated:', { isOpen, task });
  }, [isOpen, task]);

  if (!isOpen) {
    //console.log('TaskModal not rendering - isOpen is false');
    return null;
  }
  
  //console.log('TaskModal rendering with task:', task);
  
  const handleSave = () => {
    //console.log('TaskModal save button clicked');
    onSave();
    onClose();
  };
  
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      //console.log('TaskModal overlay clicked');
      onClose();
    }
  };
  
  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <TaskForm task={task} onSave={handleSave} onCancel={onClose} />
      </ModalContent>
    </ModalOverlay>
  );
};

export default TaskModal; 